













































































import { Form, FormItem, Button, RadioGroup, RadioButton } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import FieldError from '@/components/FieldError.vue'
import DepositPaymentOption from '@/components/modals/DepositPaymentOption.vue'
import FullPaymentOption from '@/components/modals/FullPaymentOption.vue'

import Booking from '@/models/booking'
import PaymentAmountOptions from '@/models/payment-amount-options'
import PaymentPresetTypes from '@/models/payment-preset-types'

import dayjs, { Dayjs } from '@/dayjs'
import { UtilityGetters } from '@/store/modules/utility'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    FullPaymentOption,
    DepositPaymentOption,
    FieldError,
  },
})
export default class AmountPaymentTab extends Vue {
  @Prop() booking!: Booking
  @Prop(String) paymentAmountOption!: PaymentAmountOptions
  @Prop(String) paymentPresetType!: PaymentPresetTypes
  @Prop() depositsAmount!: number
  @Prop() total!: number
  @Prop() amountToPay!: number
  @Prop() amountInvalid!: boolean
  @Prop() totalError!: string

  touched = false

  mounted() {
    const { everyonePaidDeposit, isFullPaymentRequired } = this

    if (everyonePaidDeposit || isFullPaymentRequired) {
      this.$emit('on-payment-preset-type-update', PaymentPresetTypes.Full)
    }
  }

  get everyonePaidDeposit(): boolean {
    return this.booking.depositRemainingCents <= 0
  }

  get presetTypes() {
    return PaymentPresetTypes
  }

  get amountOptions() {
    return PaymentAmountOptions
  }

  get currentDate(): Dayjs {
    return this.$store.getters[UtilityGetters.CurrentDate] || dayjs.utc()
  }

  get isFullPaymentRequired() {
    return this.currentDate.isSameOrAfter(
      dayjs.utc(this.booking.paymentDueDate),
    )
  }

  handleSubmit() {
    this.touch()

    this.$nextTick(() => {
      this.$emit('submit')
    })
  }

  touch() {
    this.touched = true
  }
}
